export default function (){return [
    {icon: 'fa-address-book', text: 'Setup', to: '/setup'},
    {icon: 'fa-bell', text: 'Notification Summary', to: '/notification-summary'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Plots',
        model: false,
        children: [
            {icon: 'fa-chart-line', text: 'Time Series Plots', to: '/multiplots'},
            {icon: 'fa-chart-line', text: 'Equipment Plots', to: '/equipment-plots'},
        ]
    },
    {icon: 'fa-bell', text: 'Fault Detection', to: '/fault'},
    {icon: 'fa-bell', text: 'Fault Detection (Machine Learning)', to: '/modelsummary'},
    {icon: 'fa-medkit', text: 'Equipment Health Overview', to: '/equipment-health-summary'},
    {icon: 'fa-medkit', text: 'Equipment Health Report', to: '/equipment-health-report'},
    {
        icon: 'fa-bell',
        text: 'Fault Summary',
        to: '/faults-report',
    },
    {icon: 'fa-notes-medical', text: 'Maintenance Record', to: '/maintenancerecord'}
]}
